import { useQuery } from "@tanstack/react-query";

import { tarefaService } from "@/services/api/tarefa.service";
import { TarefaMaisAtrasadaDTO } from "@/types/tarefa.type";

export function useTarefaAdminMaisAtrasadas(limit = 10, dias?: number) {
  const { data, isLoading } = useQuery<TarefaMaisAtrasadaDTO[]>({
    queryKey: ["tarefa-mais-atrasadas", limit, dias],
    queryFn: () => tarefaService.getTarefasMaisAtrasadas(limit, dias),
  });

  return { tarefas: data ?? [], loading: isLoading };
}
